import React, { Component } from "react";
// import { translate } from "react-translate";
import SegmentGroup, {
  Button,
  Icon,
  Select,
  Modal,
  Container,
  Input,
  Grid,
  Dropdown,
  Segment,
  Form,
  TextArea,
  GridRow,
  GridColumn
} from "semantic-ui-react";
import {withRouter} from 'react-router-dom'
import "./ProductBoundCRUD.css";
import API from "../../../services/Api";

const worktype = [
  { key: 1, text: "CA", value: "CA" },
  { key: 2, text: 'IME', value: 'IME'},
];

const allProductsProducts = [
  {
    id: "1",
    products_id_remote: "Produit 5",
    worktype: "CA"
  },
  {
    id: "2",
    products_id_remote: "Produit 2",
    worktype: "CA"
  }
];

class ProductBoundCRUD extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allProductsProducts: allProductsProducts,
      remoteProducts: [],
      isOpen: false,
      idCount: 2,
      selectedEvent: null,
      formMission: null,
      openModal: false,
    };
  }

  componentWillMount() {
    API.getRelProductsProducts().then(res => {
      var allProductsProducts = res.data.relproductsproducts;
      this.setState({
        allProductsProducts
      });
    });

    API.getProducts().then(({ data: { products }}) => {
      this.setState({
        remoteProducts: products.map(p => ({
          ...p,
          text: p.name,
          value: p.id,
          key: p.id,
        }))
      })
    })
  }

  handleEditOpenEvent = updatedEvent => {
    API.updateRelProductsProducts(updatedEvent).then(() => {
      this.setState({
        allProductsProducts: this.state.allProductsProducts.map(event => {
          if (event.id === updatedEvent.id) {
            return Object.assign({}, updatedEvent);
          } else {
            return event;
          }
        }),
        isOpen: false,
        selectedEvent: null
      });
    })
  };

  handleEditEvent = eventToUpdate => () => {
    this.setState({
      selectedEvent: eventToUpdate,
      isOpen: true,
      formMission: 'edit',
    });
  };

  handleCreateEvent = newEvent => {
    let curId = this.state.idCount;
    newEvent.id = curId + 1;

    let updatedallProductsProducts = [...this.state.allProductsProducts];
    updatedallProductsProducts.push(newEvent);
    this.setState({
      allProductsProducts: updatedallProductsProducts,
      isOpen: false,
      idCount: curId + 1
    });
  };

  createRelProductsProducts = (product) => {
    return API.addRelProductsProducts({
      ...product,
      products_id_master: Number(this.props.match.params.idProduct),
    }).then(() => {
      return API.getRelProductsProducts()
    }).then(res => {
      var allProductsProducts = res.data.relproductsproducts;
      this.setState({
        allProductsProducts
      });
    });
  };

  handleDeleteEvent = eventId => () => {
    API.deleteRelProduct(eventId).then(() => {
      let updatedallProductsProducts = this.state.allProductsProducts.filter(
        e => e.id !== eventId
      );
      this.setState({
        allProductsProducts: updatedallProductsProducts
      });
    })
  };

  openForm = () => {
    this.setState({
      selectedEvent: null,
      isOpen: true,
      formMisson: 'create',
    });
  };

  render() {
    return (
      <div className="dashboard">
        <EventList
          deleteEvent={this.handleDeleteEvent}
          handleEditEvent={this.handleEditEvent}
          allProductsProducts={this.state.allProductsProducts}
          remoteProducts={this.state.remoteProducts}
          match={this.props.match}
        />

        {this.state.isOpen ? (
          <EventForm
            updateEvent={this.handleEditOpenEvent}
            openForm={this.openForm}
            selectedEvent={this.state.selectedEvent}
            createEvent={this.createRelProductsProducts}
            formMisson={this.state.formMission}
            remoteProducts={this.state.remoteProducts}
          />
        ) : (
          <AddEvent openForm={() => {
            this.setState({
              openModal: true,
            })
          }} />
        )}

        <Modal
          defaultOpen={false}
          open={this.state.openModal}
          onClose={() => {
            this.setState({
              openModal: false,
            })
          }}
        >
          <EventForm
            updateEvent={this.handleEditOpenEvent}
            openForm={this.openForm}
            selectedEvent={this.state.selectedEvent}
            createEvent={(product) => {
              this.createRelProductsProducts(product).then(() => {
                this.setState({
                  openModal: false,
                })
              })
            }}
            formMisson={this.state.formMission}
            remoteProducts={this.state.remoteProducts}
          />
        </Modal>
      </div>
    );
  }
}

class EventList extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="eventList">
        <Grid columns="equal" divided>
          <Grid.Row id="rowProductEntete">
            <Grid.Column columns={6}>
              <h3 id="titleH3Product">Produit</h3>
            </Grid.Column>
            <Grid.Column columns={6}>
              <h3 id="titleH3worktype">Type de travaux</h3>
            </Grid.Column>
            <Grid.Column columns={6}>
              <h3 id="titleH3worktype">Editer</h3>
            </Grid.Column>
            <Grid.Column columns={6}>
              <h3 id="titleH3worktype">Supprimer</h3>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {(this.props.allProductsProducts || [])
          .filter(p => p.products_id_master === Number(this.props.match.params.idProduct))
          .map(event => {
          const remoteProduct = this.props.remoteProducts.filter(p => p.id === event.products_id_remote).pop()
          return (
            <EventItem
              deleteEvent={this.props.deleteEvent}
              handleEditEvent={this.props.handleEditEvent}
              event={event}
              remoteProduct={remoteProduct}
            />
          );
        })}
      </div>
    );
  }
}

class EventItem extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="eventItem">
        <Grid columns="equal" divided>
          <Grid.Row id="rowProduct">
            <Grid.Column columns={6}>
              {/* <h5>{this.props.event.location}</h5> */}
              { this.props.remoteProduct
                ? <h3 id="titleH3Product">{this.props.remoteProduct.name}</h3>
                : <h3></h3>
              }
            </Grid.Column>
            <Grid.Column columns={6}>
              {/* <h3 id="titleH3">{this.props.event.rules}</h3> */}
              <h3 id="titleH3worktype">{this.props.event.worktype}</h3>
              {/* <h3>{this.props.event.sugestion}</h3> */}
              {/* <h4>{this.props.event.info}</h4> */}
            </Grid.Column>
            <Grid.Column>
              <div className="eventItem">
                <div className="edit">
                  <Icon
                    circular
                    name="edit"
                    color="teal"
                    onClick={this.props.handleEditEvent(this.props.event)}
                    alt="edit"
                  />
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div className="eventItem">
                <div className="delete">
                  <Icon
                    circular
                    name="trash alternate"
                    color="red"
                    onClick={this.props.deleteEvent(this.props.event.id)}
                    alt="delete"
                  />
                </div>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    );
  }
}

class EventForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      event: {
        products_id_remote: "",
        worktype: "CA",
      }
    };
  }

  componentDidMount() {
    if (this.props.selectedEvent !== null) {
      this.setState({
        event: this.props.selectedEvent
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedEvent !== this.props.selectedEvent) {
      this.setState({
        event: nextProps.selectedEvent || {
          products_id_remote: "",
          worktype: "CA"
        }
      });
    }
  }

  onFormSubmit = (e, val) => {
    e.preventDefault();
    const clone = this.state.event;
    if (this.state.event.id) {
      this.props.updateEvent(this.state.event);
    } else {
      this.props.createEvent(clone);
      this.setState({
        event: {
          products_id_remote: "",
          worktype: "CA"
        }
      });
    }
  };

  onInputChange = (e, val) => {
    const newEvent = this.state.event;
    newEvent[e.target.name] = e.target.value;

    this.setState({
      event: newEvent
    });
  };

  onDropdownChange = (e, val) => {
    const newEvent = this.state.event;
    newEvent[val.name] = val.value;
    this.setState({
      event: newEvent
    });
  };

  render() {
    const style = this.props.selectedEvent === null
      ? {
        backgroundColor: this.props.selectedEvent == null ? 'white' : '',
        position: this.props.selectedEvent == null ? 'unset' : '',
        width: '100%',
        margin: 0,
      }
      : {}

    return (
      <div className="eventForm" style={style}>
        <form onSubmit={this.onFormSubmit}>
          <Select
            id="selectDropdownInput"
            fluid
            selection
            search
            name="worktype"
            onChange={this.onDropdownChange}
            defaultValue={this.state.event.worktype}
            value={this.state.event.worktype}
            type="select"
            options={worktype}
            placeholder="Types"
          />
          <Select
            id="selectDropdownInput"
            fluid
            search
            selection
            name="products_id_remote"
            onChange={this.onDropdownChange}
            defaultValue={this.state.event.products_id_remote}
            value={this.state.event.products_id_remote}
            type="select"
            options={this.props.remoteProducts}
            placeholder="Produits"
          />

          <input
            type="submit"
            value="Ajouter un produit lié"
            onClick={this.createRelProductsProducts}
          />
        </form>
      </div>
    );
  }
}

class AddEvent extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="addEvent">
        <Button onClick={this.props.openForm} alt="createEvent">
          Ajouter un produit lié
        </Button>
        {/*<div onClick={this.props.openForm} className="btn"><p>N<br/>E<br/>W<br/> <br/>E<br/>V<br/>E<br/>N<br/>T</p></div>*/}
      </div>
    );
  }
}

export default withRouter(ProductBoundCRUD);



// WEBPACK FOOTER //
// ./src/components/Protected/Article/ProductBoundCRUD.js